import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'rc-menu/assets/index.css';
import { insertCss } from '@rexlabs/styling';

import data from 'data/menu';

import CommonMenu from './CommonMenu';

insertCss(`
    .rc-menu-horizontal {
        background-color: transparent !important;
        border: none !important;
    }
    .rc-menu {
        cursor: pointer;
        text-decoration: none;
        border: none !important;
        box-shadow: none !important; 
        border-radius: 0px !important;
        text-align: left !important;
    }
    .rc-menu-horizontal > .rc-menu-submenu-active,
    .rc-menu-horizontal > .rc-menu-item-active {
        color: #fff !important;
        background-color: transparent !important;
        border: none !important;
    }
    
    .rc-menu-submenu-active > .rc-menu-submenu-title {
        background-color: transparent !important;
    }
    
    .rc-menu-submenu-title {
        text-align: left;
    }
    
    .rc-menu-item {
        background: transparent: 
    }
    
    .rc-menu-sub {
        text-align: left;
    }
    
    .rc-menu-item-active {
        background-color: transparent !important;
    }
`);

class VerticalMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props
    };
  }

  render() {
    const {
      menu,
      menuFontColor,
      menuFontHoverColor,
      menuDropdownBackgroundColor,
      menuBackgroundColor
    } = this.state;
    return (
      <div>
        <CommonMenu
          mode='inline'
          // use openTransition for antd
          openAnimation='slide-up'
          menu={menu.items}
          menuFontColor={menuFontColor}
          menuItemHoverColor={menuFontHoverColor}
          menuDropdownBackgroundColor={menuDropdownBackgroundColor}
          menuBackgroundColor={menuBackgroundColor}
        />
      </div>
    );
  }
}

VerticalMenu.propTypes = {
  menu: PropTypes.object
};

VerticalMenu.defaultPrrops = {
  menu: data
};

export default VerticalMenu;
